module.exports = __webpack_public_path__ + "img/enps.78b23ac4.jpg";